<ng-container>
    <app-input
        class="location-autocomplete__input"
        #input
        [icon]="ICONS.MARKER_PIN"
        [fc]="fc"
        [label]="label"></app-input>
</ng-container>
